module.exports = __webpack_public_path__ + "img/mob-video.e82d64ca.svg";